import { FlightShopActions, type FlightState } from "@b2bportal/core-flights";
import {
  type PackageFlightShopRequest,
  type PackageFlightShopResponse,
  packagesApi,
} from "@b2bportal/packages-api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchPackageFlights = createAsyncThunk<
  PackageFlightShopResponse,
  { searchToken: string },
  { state: FlightState; rejectValue: { error: string } }
>("packages/fetchFlights", async ({ searchToken }, thunkAPI) => {
  try {
    const requestBody: PackageFlightShopRequest = {
      opaquePackageToken: {
        value: searchToken,
      },
    };
    thunkAPI.dispatch(FlightShopActions.setFetchFlightsPending());

    const res =
      await packagesApi(axios).apiV0PackagesFlightsShopPost(requestBody);

    if (res.data.PackageFlightShopResponse !== "Available") {
      throw new Error("Flight shop data is not available");
    }

    const data = res.data;

    thunkAPI.dispatch(
      FlightShopActions.setFetchFlightsSuccess(data.response.value)
    );

    return data;
  } catch (error) {
    // Reject the thunk with an error message
    thunkAPI.dispatch(FlightShopActions.setFetchFlightsRejected());
    return thunkAPI.rejectWithValue({ error: String(error) });
  }
});
